import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from './i18n/intl_en.json';
import deTranslations from './i18n/intl_de.json';
import enGpsrTranslations from './i18n/gpsr_module_en.json';
import deGpsrTranslations from './i18n/gpsr_module_de.json';
import enGpsrQuestionsTranslations from './i18n/gpsr_questions_en.json';
import deGpsrQuestionsTranslations from './i18n/gpsr_questions_de.json';

interface Translation {
  [key: string]: string | Translation;
}

const enTranslationsTyped: Translation = enTranslations;
const deTranslationsTyped: Translation = deTranslations;

const enGpsrTranslationsTyped: Translation = enGpsrTranslations;
const deGpsrTranslationsTyped: Translation = deGpsrTranslations;

const enGpsrQuestionsTranslationsTyped: Translation = enGpsrQuestionsTranslations;
const deGpsrQuestionsTranslationsTyped: Translation = deGpsrQuestionsTranslations;

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { 
        translation: enTranslationsTyped, 
        gpsr: enGpsrTranslationsTyped, 
        questions: enGpsrQuestionsTranslationsTyped
      },
      de: { 
        translation: deTranslationsTyped, 
        gpsr: deGpsrTranslationsTyped, 
        questions: deGpsrQuestionsTranslationsTyped
      },
    },
    lng: localStorage.getItem('selectedLanguage') || 'de',
    fallbackLng: 'de',
    ns: ['translation', 'gpsr', 'questions'],
    defaultNS: ['translation'],
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;